// extracted by mini-css-extract-plugin
export default {"completeItem":"CompleteItem_completeItem__EP3+Y","completeItemImg":"CompleteItem_completeItemImg__fIrV7","completeItemText":"CompleteItem_completeItemText__YPJ+f"};